const $document = $(document);

const changeColorName = () => {
  $document.on('change', '.js-product-main-select', function() {
    const $this = $(this);
    const $product = $this.closest('.js-pdp');
    const $colorNameContainer = $product.find('.js-pdp-color-name');
    const currentColorName = $product.find('.swatches input:checked').data('color-name');

    $colorNameContainer.text(currentColorName);
  });
}

changeColorName();
